// extracted by mini-css-extract-plugin
module.exports = {"container":"_b9e6d34e","title":"_3de68289","subtitle":"_6437da8d"};